import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BudgetListItem } from 'types/api/budgets.type';

import { useAppSelector } from 'redux/hooks';

import { budgetDataService } from 'services/budget.service';

import { LayoutContext } from 'contexts';

import { useFetch } from 'hooks';

import { formatSeasonLabel } from 'helpers/formatSeason';

import { useColumns } from './columns.data';

const useList = () => {
  const columns = useColumns();
  const { t, i18n } = useTranslation();

  const { breadcrumbSet, breadcrumbSecondarySet } = useContext(LayoutContext);

  const { season, marketLine, zone } = useAppSelector((state) => state.settings);

  const [budgets, budgetsSet] = useState<BudgetListItem[]>();

  const { content, isLoading } = useFetch(
    season && marketLine && zone
      ? () => budgetDataService.getAll(season, marketLine, zone)
      : undefined,
    [season, marketLine]
  );

  const tableData = budgets?.map((item) => ({
    num: item.num,
    name: item.name,
    date: item.startDate,
    id: item.num,
    genderCode: item.genderCode,
    type: item.type,
  }));

  useEffect(() => {
    const breadcrumb = [
      {
        label: t('nav.manageBudgets'),
      },
    ];

    breadcrumbSet(breadcrumb);

    if (season) {
      const breadcrumbSecondary = [
        {
          label: formatSeasonLabel(season),
        },
        {
          label: t('nav.budgets'),
        },
      ];

      breadcrumbSecondarySet(breadcrumbSecondary);
    }
  }, [season, i18n.language]);

  useEffect(() => {
    if (content) {
      // Ensure budgets are ordered by number, not by name
      const sortedByNumber = [...content].sort((a, b) => a.num - b.num);
      budgetsSet(sortedByNumber);
    }
  }, [content]);

  return {
    columns,
    isLoading,
    tableData,
  };
};

export { useList };
